import { AxiosInstance } from 'axios';
import {
  ProductResponse,
  ProductsResponse,
} from 'data/terra/api/terra/response/ProductResponse';
import { ProductDescription } from 'data/terra/Product';
import { result, Result } from 'util/result';
import Terra from '../Terra';

class ProductEndpoint {
  getProductsUrl = () =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/products`;
  getProductDetailUrl = (productId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/products/${productId}`;
}

export class ProductApi {
         terraClient: AxiosInstance;
         endpoint = new ProductEndpoint();

         constructor(client: AxiosInstance) {
           this.terraClient = client;
         }

         fetchProduct(productId: string): Promise<Result<ProductResponse>> {
           return result(
             async () =>
               (
                 await this.terraClient.get<ProductResponse>(
                   this.endpoint.getProductDetailUrl(productId)
                 )
               ).data
           );
         }

         fetchProducts({
           page,
           pageSize = 200,
           sortBy = '+name',
         }: {
           page: number;
           pageSize?: number;
           sortBy?: String;
         }): Promise<Result<ProductsResponse>> {
           return result(
             async () =>
               (
                 await this.terraClient.get<ProductsResponse>(
                   this.endpoint.getProductsUrl(),
                   {
                     params: {
                       page,
                       pageSize,
                       sortBy,
                     },
                   }
                 )
               ).data
           );
         }

         addProduct(
           desc: ProductDescription
         ): Promise<Result<ProductResponse>> {
           return result(
             async () =>
               (
                 await this.terraClient.post<ProductResponse>(
                   this.endpoint.getProductsUrl(),
                   desc
                 )
               ).data
           );
         }
       }